import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-md'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/10a32120-472c-4553-83a2-a33e58379a7a.png" 
                alt="SayItBetter Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-semibold text-gray-800">SayItBetter</span>
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link 
                to="/" 
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Home
              </Link>
              <Link 
                to="/analyzer" 
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/analyzer') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Analyzer
              </Link>
              <Link 
                to="/learning" 
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/learning') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                Learning
              </Link>
              <Link 
                to="/parent-info" 
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/parent-info') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                For Parents
              </Link>
              <Link 
                to="/analyzer" 
                className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Try Now
              </Link>
            </div>

            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-16">
          <div className="flex flex-col items-center justify-center h-full space-y-8 px-4">
            <Link 
              to="/" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-lg font-medium transition-colors ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/analyzer" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-lg font-medium transition-colors ${
                isActive('/analyzer') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Analyzer
            </Link>
            <Link 
              to="/learning" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-lg font-medium transition-colors ${
                isActive('/learning') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Learning
            </Link>
            <Link 
              to="/parent-info" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-lg font-medium transition-colors ${
                isActive('/parent-info') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              For Parents
            </Link>
            <Link 
              to="/analyzer" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-8 py-3 bg-blue-600 text-white text-base font-semibold rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Try Now
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
